import React from 'react';
import { Modal, ModalProps } from 'reactstrap';
import merge from 'classnames';

type Props = ModalProps & {
  fullscreen?: boolean;
  confirmation?: boolean;
  zIndex?: number;
  testId?: string;
};

export const ModalProxy = ({ fullscreen, confirmation, testId, ...props }: Props) => {
  const zIndex = confirmation ? 1030 : undefined;

  return (
    <Modal
      {...props}
      className={merge(props.className, { fullscreen: fullscreen })}
      data-testid={testId}
      zIndex={props.zIndex ?? zIndex}
    />
  );
};
